
export default function WhyChooseUs() {
  const advantages = [
    {
      icon: 'ri-medal-fill',
      title: 'Plombier diplômé ITS',
      description: 'Certification Installations Techniques Sanitaires garantissant un savoir-faire professionnel reconnu.'
    },
    {
      icon: 'ri-flashlight-fill',
      title: 'Intervention rapide et soignée',
      description: 'Nous intervenons rapidement tout en garantissant des finitions impeccables et durables.'
    },
    {
      icon: 'ri-file-list-3-fill',
      title: 'Devis gratuit et transparent',
      description: 'Estimation détaillée sans engagement. Tarifs clairs et sans surprise.'
    },
    {
      icon: 'ri-star-fill',
      title: 'Matériaux de qualité professionnelle',
      description: 'Nous utilisons uniquement des équipements et matériaux de marques reconnues pour leur fiabilité.'
    },
    {
      icon: 'ri-leaf-fill',
      title: 'Respect des normes et de l\'environnement',
      description: 'Conformité aux réglementations en vigueur et solutions éco-responsables.'
    }
  ];

  return (
    <section className="py-20 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#F5A623]/10 px-4 py-2 rounded-full mb-6">
              <i className="ri-thumb-up-fill text-[#F5A623]"></i>
              <span className="text-[#0F5E7E] font-semibold text-sm">POURQUOI NOUS CHOISIR</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-[#0F5E7E] mb-6">
              L'excellence au service de votre confort
            </h2>
            
            <p className="text-xl text-gray-600 mb-10 leading-relaxed">
              PLOMB'ART combine expertise technique, réactivité et approche artisanale pour vous garantir des prestations de qualité supérieure.
            </p>

            <div className="space-y-6">
              {advantages.map((advantage, index) => (
                <div key={index} className="flex gap-4 group cursor-pointer">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#F5A623]/10 rounded-lg flex items-center justify-center group-hover:bg-[#F5A623] transition-colors duration-300">
                    <i className={`${advantage.icon} text-[#F5A623] text-xl group-hover:text-white transition-colors duration-300`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#0F5E7E] mb-2 group-hover:text-[#F5A623] transition-colors">
                      {advantage.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {advantage.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/ecc770286f45351cd24eefe238a15de4.jpg"
                alt="Plombier professionnel PLOMB'ART"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 bg-[#0F5E7E] text-white p-8 rounded-xl shadow-xl">
              <div className="text-5xl font-bold mb-2">7j/7</div>
              <div className="text-lg">Disponible pour<br />vos urgences</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
